import { RequestLocalization } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { Coordinate } from '@models/coordinate';
import { LocalizePositionService } from '../../localize-position/localize-position.service';

@Injectable()
export class RequestLocalizeService implements RequestLocalization {
  constructor(private localizePosition: LocalizePositionService) {}

  requestLocalize(coordinates: Coordinate, zoom?: number) {
    this.localizePosition.localize({
      coordinates: [coordinates],
      target: null,
      zoom: zoom
    });
  }
}
